
import { defineComponent } from "vue";

import ScannerFeature from "../features/Scanner.vue";

export default defineComponent({
  components: { ScannerFeature },
});
